export enum RequestLawyerLicenseStatus {
	Valid = "VALID",
	Expired = "EXPIRED",
}
